// API Configuration - Production Ready
const BACKEND_URL = (process.env.REACT_APP_API_URL || 'http://localhost:5000').trim();
const FRONTEND_URL = (process.env.REACT_APP_FRONTEND_URL || 'http://localhost:5000').trim();

// Authentication endpoints
const AUTH = {
  LOGIN: `${BACKEND_URL}/auth/login`,
  SIGNUP: `${BACKEND_URL}/auth/signup`,
  PHONE_LOGIN: `${BACKEND_URL}/auth/phone-login`,
  VERIFY_OTP: `${BACKEND_URL}/auth/verify-otp`,
};

// Product endpoints
const PRODUCTS = {
  LIST: `${BACKEND_URL}/gold`,
  DETAIL: (id) => `${BACKEND_URL}/gold/${id}`,
  FEATURED: `${BACKEND_URL}/feature`,
  BEST_SELLING: `${BACKEND_URL}/best`,
  EVERYDAY: `${BACKEND_URL}/Everyday`,
  CAROUSEL: `${BACKEND_URL}/crousel`,
  GOLD: `${BACKEND_URL}/gold`,
};

// Category endpoints
const CATEGORIES = {
  ALL: `${BACKEND_URL}/category/getAllCategory`,
  PRODUCTS: (categoryId) => `${BACKEND_URL}/gold?category=${categoryId}`
};

// Wishlist endpoints
const WISHLIST = {
  BASE: `${BACKEND_URL}/wishlist/wishlist`,
  USER: (userId) => `${BACKEND_URL}/wishlist/wishlist/${userId}`,
  REMOVE: (userId, productId) => `${BACKEND_URL}/wishlist/remove/${userId}/${productId}`,
};

// Cart endpoints
const CART = {
  BASE: `${BACKEND_URL}/cart`,
  ADD: `${BACKEND_URL}/cart/add`,
  USER: (userId) => `${BACKEND_URL}/cart/user/${userId}`,
};

// Support endpoints
const SUPPORT = {
  TICKETS: `${BACKEND_URL}/ticket/tickets`,
  CREATE_TICKET: `${BACKEND_URL}/support`,
};

// Media Management endpoints (for homepage - public access)
const MEDIA = {
  FEATURES: `${BACKEND_URL}/api/media/features`,
  BANNERS: `${BACKEND_URL}/api/media/banners`,
  LOGO: `${BACKEND_URL}/api/media/logo`,
  BEST_SELLING: `${BACKEND_URL}/api/media/best-selling`,
  EVERYDAY: `${BACKEND_URL}/api/media/everyday`,
  CATEGORIES: `${BACKEND_URL}/api/categories`,
};

// Other endpoints
const OTHER = {
  TESTIMONIALS: `${BACKEND_URL}/testimonial`,
  CAROUSEL: `${BACKEND_URL}/crousel`,
  INSTAGRAM: `${BACKEND_URL}/instagram`,
  GOLD_PRICE: `${BACKEND_URL}/today-price/PriceRouting`,
};

// WebSocket configuration - Using HTTPS for production
const WS_CONFIG = {
  BASE: (process.env.REACT_APP_WS_URL || 'wss://localhost:5000').trim(),
  GOLD_PRICE: process.env.REACT_APP_WS_URL ? `${process.env.REACT_APP_WS_URL.trim()}/ws/goldprice` : 'wss://localhost:5000/ws/goldprice',
};

export {
  BACKEND_URL,
  FRONTEND_URL,
  AUTH,
  PRODUCTS,
  CATEGORIES,
  WISHLIST,
  CART,
  SUPPORT,
  MEDIA,
  OTHER,
  WS_CONFIG,
};

// Log the configuration for debugging
console.log('API Configuration loaded:', {
  BACKEND_URL,
  FRONTEND_URL,
  AUTH,
  PRODUCTS,
  CATEGORIES,
  WISHLIST,
  CART,
  SUPPORT,
  MEDIA,
  OTHER,
  WS_CONFIG,
});
